import React from 'react';
import PropTypes from 'prop-types';
import { StyledGaugeTooltip } from './GaugeTooltip.styles';

/**
 * The small stat-rows box a gauge's hover tooltip shows — pass it as
 * `hoverTooltipContent` to `Gauge`. Each row is pre-formatted by the caller
 * (a post count, a percentage, a score — the tooltip itself is generic).
 */
const GaugeTooltip = ({ rows }) => (
  <StyledGaugeTooltip>
    {rows.map((row) => (
      <div className='tooltip-row' key={row.key}>
        <span className='tooltip-value'>{row.value}</span>
        <span className='tooltip-label'>{row.label}</span>
      </div>
    ))}
  </StyledGaugeTooltip>
);

GaugeTooltip.propTypes = {
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      value: PropTypes.node,
      label: PropTypes.node,
    })
  ).isRequired,
};

export default GaugeTooltip;
